module.exports = __webpack_public_path__ + "media/soundtrack.2e4c9713.mp3";